import { token } from 'odyssey';
import styled from 'styled-components';

export const Container = styled.div`
  display: inline-block;
  background-color: #faeae9;
  padding: ${token('space-3')} ${token('space-4')};
  border-radius: ${token('border-radius-md')};
  color: ${token('color-negative-semantic')};
  border: solid 1px ${token('color-negative-semantic')};
  font-weight: bold;
`;
